/* eslint-disable max-depth */
/* eslint-disable no-continue */
import React from 'react';
import { jsonLdScriptProps } from 'react-schemaorg';
import { Article } from 'schema-dts';
import Head from 'next/head';
import { PageType } from 'types/publishedAssets';
import { useGetContentTranslations } from 'utils/useGetContentTranslations';
import { determinePageHeadline } from '../PageHelpers';

interface PageProps {
  page: PageType;
}
export function ArticleStructuredData(props: PageProps): JSX.Element | null {
  const { page } = props;
  const type = page?.page_type;
  const { translate, getMediaItem } = useGetContentTranslations();

  const heroImageArray: string[] = [];
  const getHeroImage = () => {
    const heroContent = page?.sections?.[0]?.section_entities?.[0];
    if (!heroContent) return null;
    if (heroContent.content_type !== 'hero') return null;
    const heroImage = getMediaItem(heroContent, 0)?.url;
    if (heroImage) {
      heroImageArray.push(heroImage);
    }
  };
  getHeroImage();
  const authorArray: { '@type': 'Person'; name: string }[] = [];
  const getAuthor = () => {
    for (let sectionIt = 0; sectionIt < page?.sections?.length; sectionIt++) {
      const section = page?.sections?.[sectionIt];
      for (let entityIt = 0; entityIt < section?.section_entities?.length; entityIt++) {
        const entity = section?.section_entities?.[entityIt];
        if (!entity) continue;
        if (entity.content_type !== 'whos_listening') continue;
        for (let componentIt = 0; componentIt < entity?.components?.length; componentIt++) {
          const component = entity?.components?.[componentIt];
          if (!component) continue;
          if (component.content_component_type !== 'person') continue;
          const person = translate(component.translations, 'name');
          if (person) {
            authorArray.push({ '@type': 'Person', name: person });
          }
        }
      }
    }
  };
  getAuthor();

  // Project Pages and Updates are also articles
  if (type === 'project' || type === 'update') {
    const structuredData = jsonLdScriptProps<Article>({
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: determinePageHeadline(page, translate),
      image: heroImageArray,
      datePublished: page.created_at,
      dateModified: page.updated_at,
      author: authorArray,
    });
    return (
      <Head>
        <script
          key="structured-data-article"
          type="application/ld+json"
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...structuredData}
        />
      </Head>
    );
  }

  return null;
}
